/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type FilterDeleteModalMutationVariables = {|
  id: string
|};
export type FilterDeleteModalMutationResponse = {|
  +labelGroupDelete: ?{|
    +deleted: ?boolean
  |}
|};
export type FilterDeleteModalMutation = {|
  variables: FilterDeleteModalMutationVariables,
  response: FilterDeleteModalMutationResponse,
|};
*/


/*
mutation FilterDeleteModalMutation(
  $id: ID!
) {
  labelGroupDelete(input: {id: $id}) {
    deleted
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id",
    "type": "ID!"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "fields": [
          {
            "kind": "Variable",
            "name": "id",
            "variableName": "id"
          }
        ],
        "kind": "ObjectValue",
        "name": "input"
      }
    ],
    "concreteType": "LabelGroupDeletePayload",
    "kind": "LinkedField",
    "name": "labelGroupDelete",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "deleted",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "FilterDeleteModalMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "FilterDeleteModalMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "FilterDeleteModalMutation",
    "operationKind": "mutation",
    "text": "mutation FilterDeleteModalMutation(\n  $id: ID!\n) {\n  labelGroupDelete(input: {id: $id}) {\n    deleted\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '2b1622bf3568cc5e5d349487d4ecd1c7';

module.exports = node;
